import sectionSaintbrandReviewsCss from '../css-snippets/section-saintbrand-reviews';

const STAR_PATH =
  'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z';

const overviewStarSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="${STAR_PATH}"></path></svg>`;

const closeIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>`;

const overviewStars = Array(5)
  .fill(overviewStarSvg)
  .join('');

const rateListRows = [5, 4, 3, 2, 1]
  .map(rate => {
    const isTopRate = rate === 5;
    return `
              <tr class="rate-item" data-rate-value="${rate}">
                <td class="rate-value"> ${rate}</td>
                <td class="rate-star">
                  ${overviewStarSvg}
                </td>
                <td class="rate-bar">
                  <div class="rate-bar-bg">
                    <div class="rate-bar-fill" style="width: ${isTopRate ? '100%' : '0%'}"></div>
                  </div>
                </td>
                <td class="rate-count">${isTopRate ? '10' : '0'}</td>
              </tr>`;
  })
  .join('');

const html = `
<style>${sectionSaintbrandReviewsCss}</style>
<div
  class="product-reviews-wrapper product-reviews-wrapper-unique-id"
  data-id="unique-id"
  data-attribute="product-reviews-container"
  style="background-color: #ffffff"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="container">
    <div class="wrap-product-reviews">
      <div
        class="review-overview"
        data-attribute="review-overview"
        style="background-color: #ffffff"
      >
        <div class="review-header" data-attribute="review-title">
          <h2>
            <strong>Customer reviews</strong>
          </h2>
        </div>
        <div
          class="review-overview-stats"
          data-attribute="review-overview-stats"
        >
          <div class="review-stats" data-attribute="review-stats">
            <div class="rating-summary" data-attribute="rating-summary">
              <div class="rating-score" data-attribute="rating-score">5</div>
              <div class="rating-score-container" data-attribute="rating-score-container">
                <div
                    class="wrap-stars"
                    data-full-stars="5"
                    data-attribute="wrap-stars"
                  >
                    ${overviewStars}
                  </div>
                <div
                  class="reviewers-count-container"
                  data-attribute="reviewers-count-container"
                >
                  Based on
                  <span class="reviewers-count" data-attribute="reviewers-count">
                    10
                  </span>
                  reviews
                </div>
              </div>
            </div>
            <table class="rate-list" data-attribute="rate-list">
              <tbody>
                ${rateListRows}
              </tbody>
            </table>
          </div>
          <div
            class="customer-images-container"
            data-attribute="customer-images-container"
          >
            <button
              type="button"
              class="button-write-review"
              data-attribute="button-write-review"
            >
              WRITE A REVIEW
            </button>
          </div>
        </div>
      </div>
      </div>
    <div class="reviews-list">
        <div class="reviews-container"></div>
      </div>
  </div>
</div>

<div
  onclick="window.closeImageModal()"
  class="modal-preview-image"
  style="display: none"
>
  <div onclick="event.stopPropagation()" class="modal-preview-image-content">
    <img loading="lazy" data-attribute="modal-preview-image" src="" alt="" />
    <button
      type="button"
      class="close-modal-preview-image"
      data-attribute="close-modal-preview-image"
      onclick="window.closeImageModal()"
    >
      ${closeIconSvg}
    </button>
  </div>
</div>
`;
export default html;
